import {executeFunction} from './namedArgs.js';

function prepareEvents(event){
  if(!Array.isArray(event)){
    event = event.replace(/\s/g,',').split(',');
  }  

  return event.map(e=>e.toLowerCase());
}

export default class Events {
  constructor(host, { internalEvents, preserveInternalEvents }={}){
    this._listeners = {};
    this.host = host;
    this.preserveInternalEvents = preserveInternalEvents;
    this.internalEvents = _.reduce(internalEvents,(res,e)=>{
      res[e.toLowerCase()]=true;
      return res;
    },{});
    var me = this;

    host.on = (event, handler, handlerContext, internal) => this.on(event, handler, handlerContext, internal);
    host.once = (event, handler, handlerContext, internal) => this.once(event, handler, handlerContext, internal);
    host.un = (event, handler, handlerContext, internal) => this.un(event, handler, handlerContext, internal);
    host.off = (event, handler, handlerContext, internal) => this.un(event, handler, handlerContext, internal);
    
    host.fire = function() { me.fire.apply(me, arguments); };

    host.fireArgs = function(event, args) { me.fireArgs(event, args); };

    host.addTrigger = (event, handler, handlerContext) => this.on(event, handler, handlerContext, true);
    host.addOneTimeTrigger = (event, handler, handlerContext) => this.once(event, handler, handlerContext, true);
    host.removeTrigger = (event, handler, handlerContext) => this.un(event, handler, handlerContext, true);
    host.raiseEvent = function() { me.fire.apply(me, arguments); };

    host.addConsumer = (event, handler, handlerContext) => this.on(event, handler, handlerContext, false);
    host.addOneTimeConsumer = (event, handler, handlerContext) => this.once(event, handler, handlerContext, false);
    host.removeConsumer = (event, handler, handlerContext) => this.un(event, handler, handlerContext, false);
  }

  on(event, handler, handlerContext, internal=null) {
    handler = {
      handler,
      context:handlerContext,
      internal
    };
    
    event = prepareEvents(event);
    _.each(event, (e) => {

      if (!this._listeners[e]) {
        this._listeners[e] = [];
      }

      if(!this._listeners[e].some((h)=>
        h.handler===handler.handler && 
        h.context===handler.context &&
        h.internal === handler.internal)){
        this._listeners[e].push(handler);         
      }

    });
  }

  un(event, handler, handlerContext, internal) {
    event = prepareEvents(event);
    handler.skip = true;        
    _.each(event, (e) => {
      if (this._listeners[e]) {
        setTimeout(()=>{
          _.remove(this._listeners[e], (h) => 
            h.handler===handler && 
            (handlerContext === undefined || h.context===handlerContext) &&
            (internal === undefined || h.internal === internal));
        });
      }
    });
  }

  fireArgs(event,args) {
    event = event.toLowerCase();
    let handlers = (this._listeners[event]||[]).concat(this._listeners['*']||[]);
    _.each(handlers, (handler) => {
      try {
        if(handler &&
           handler.handler &&
           !handler.skip &&
           ( handler.internal===null||
             (handler.internal && this.internalEvents[event])||
             (!handler.internal && !this.internalEvents[event])
           )
          ){
          executeFunction(handler.handler, {event,...args},handler.context || this.host);
        }
      } catch (exc) {
        const _hostArgs = this.host && this.host.args;
        const _hostName = (this.host && this.host.options && this.host.options.chartName) || (_hostArgs && _hostArgs.name) || '';
        const _hostCid = (_hostArgs && _hostArgs.cid) || '';
        const _hostLabel = _hostName ? (_hostCid ? `${_hostName} [${_hostCid}]` : _hostName) : _hostCid;
        console.error(`Event "${event}" trigger failed${_hostLabel ? ` in component "${_hostLabel}"` : ''}: `, exc);
      }
    });
  }

  fire() {
    var event = arguments[0].toLowerCase();
    var args = arguments;

    let handlers = (this._listeners[event]||[]).concat(this._listeners['*']||[]);
    _.each(handlers, (handler) => {
      try {
        if(handler &&
           handler.handler &&
           !handler.skip &&
           ( handler.internal===null||
             (handler.internal && this.internalEvents[event])||
             (!handler.internal && !this.internalEvents[event])
           )
          ){
          handler.handler.apply(handler.context || this.host, args);
        }
      } catch (exc) {
        const _hostArgs = this.host && this.host.args;
        const _hostName = (this.host && this.host.options && this.host.options.chartName) || (_hostArgs && _hostArgs.name) || '';
        const _hostCid = (_hostArgs && _hostArgs.cid) || '';
        const _hostLabel = _hostName ? (_hostCid ? `${_hostName} [${_hostCid}]` : _hostName) : _hostCid;
        console.error(`Event "${event}" trigger failed${_hostLabel ? ` in component "${_hostLabel}"` : ''}: `, exc);
      }
    });
  }

  once(event, handler, handlerContext, internal) {
    const me = this;
    this.on(event, handler, handlerContext, internal);

    function clear() {
      // handler.skip = true;
      // clear.skip = true;
      // setTimeout(function() {
        me.un(event, handler, handlerContext, internal);
        me.un(event, clear, handlerContext, internal);
      // }, 0);
    }

    this.on(event, clear, handlerContext, internal);
  }

  clear(){
    if(_.isEmpty(this.internalEvents)||!this.preserveInternalEvents){
      this._listeners = {};      
    }else{
      _.keys(this._listeners).forEach(k=>{
        if(!this.internalEvents[k]){
          delete this._listeners[k];
        }
      });
    }
  }

  destroy(){
    this._listeners = {};
    setTimeout(()=>{
      this.host.on = ()=>{};

      this.host.once = ()=>{};

      this.host.un = ()=>{};

      this.host.off = ()=>{};

      this.host.fire = ()=>{};
      
      this.host.fireArgs = ()=>{};

      this.host.addTrigger = ()=>{};

      this.host.addOneTimeTrigger = ()=>{};

      this.host.removeTrigger = ()=>{};

      this.host.raiseEvent = ()=>{};

      this.host.addConsumer = ()=>{};

      this.host.addOneTimeConsumer = ()=>{};

      this.host.removeConsumer = ()=>{};

      delete this.host;
    },0);
  }

  log(){
    console.log(_.map(this._listeners, (list, e)=>`${e}:${list.length}`));
  }
}